<div class="input-group">
    <input class="form-control"
           container="body"
           [formControl]="formControl"
           [formlyAttributes]="field"
           [minDate]="to.templateOptions?.minDate"
           [maxDate]="to.templateOptions?.maxDate"
           ngbDatepicker #d="ngbDatepicker">
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
        <i class="fa fa-calendar"></i>
      </button>
    </div>
  </div>
